module.exports = __webpack_public_path__ + "img/right-arrow.7303c972.svg";